<template>
  <CDialog
    :visible.sync="visible"
    :title="$t('Are You Sure?')"
    submittable
    :submit-label="$t('Yes')"
    width="640px"
    closeable
    :submit-loading="loading"
    @submit="onDelete"
  >
    {{ $t('Are you sure you want to delete the alert?') }}
  </CDialog>
</template>

<script>
import CDialog from '@/components/uikit/CDialog/index.vue';
import { mapActions } from 'vuex';

const messages = {
  en: {
    'Are You Sure?': 'Are You Sure?',
    'Are you sure you want to delete the alert?': 'Are you sure you want to delete the alert?',
    Yes: 'Yes',
    budget_alert_deleted: 'Budget Alert Deleted',
    error_occurred: 'Error Occurred',
  },
  ja: {
    'Are You Sure?': 'アラートの削除',
    'Are you sure you want to delete the alert?':
      'アラートを削除します。\nこの操作は取り消しができません。',
    Yes: '削除する',
    budget_alert_deleted: '予算アラートの削除',
    error_occurred: 'エラー発生',
  },
};

export default {
  name: 'DeleteAlertDialog',
  components: { CDialog },
  i18n: { messages },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    ...mapActions('notificationSettings', ['deleteAlert']),

    async onDelete() {
      this.loading = true;
      try {
        await this.deleteAlert(this.id);
        this.$alpha.notify.custom({ type: 'success', message: this.$t('budget_alert_deleted') });
      } catch (err) {
        this.$alpha.notify.custom({ type: 'danger', message: this.$t('error_occurred') });
      }
      this.loading = false;
      this.visible = false;
    },
  },
};
</script>
